import React, {useEffect, useState} from 'react'
import Swal from 'sweetalert2'
import {CircularProgress} from '@mui/material'
import {useNavigate} from 'react-router-dom'
import PaginationComponent from '../../PaginationComponent/Pagination'
import {BlockUser, UnblockUser, list_User} from './SuperAdminUser_Api'
import AddUserModal from './Components/AddUserModal'
import ChangeSubscriptionModal from './Components/ChangeSubscriptionModal'

interface userDataDataType {
  account_uuid: string
  account_verified: number
  accouont_holder_name: string
  contact_number: string
  country_name: string
  created_date: string
  email_id: string
  is_active: number
  property_account_type_name: string
  subscription_id: number
  subscription_name: string
  subscription_plan_status: string
}
const SuperAdminUser = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(true)
  const [noDataFound, setNoDataFound] = useState<boolean>()
  const [userData, setUserData] = useState<userDataDataType[]>()
  const [dataLength, setDataLength] = useState<number>(0)
  const [showAddUserModal, setShowAddUserModal] = useState<boolean>()
  const [blockLoading, setBlockLoading] = useState<string | null>()
  const [showSubscriptionModal, setShowSubscriptionModal] = useState<string | null>()
  const [itemOffset, setItemOffset] = useState<number>(0)
  const [currentPage, setCurrentPage] = useState<number>(1)
  const itemsPerPage = 20
  const pageCount = Math.ceil(dataLength / itemsPerPage)
  //   function to get users
  async function getUser() {
    setLoading(true)
    try {
      const response = await list_User(currentPage)
      if (response.status === 200) {
        if (response.data.data.length !== 0) {
          setNoDataFound(false)
          setUserData(response.data.data.users)
          setDataLength(response.data.data.totalProperties)
        } else {
          setNoDataFound(true)
          setUserData([])
          setDataLength(0)
        }
      } else {
        setNoDataFound(true)
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.data.msg.charAt(0).toUpperCase() + response.data.msg.slice(1),
          text: response.data.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setLoading(false)
    }
  }


  useEffect(() => {
    getUser()
  }, [currentPage])

  // routing to property page for user
  const navigateProperty = (property_uuid: string) => {
    navigate('/super_admin_user/property', {
      state: {property_uuid: property_uuid},
    })
  }

  // function to block the users
  const blockUser = (account_uuid: string) => {
    Swal.fire({
      title: 'Are you sure that you want to block this user?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes',
    }).then(async (result) => {
      if (result.isConfirmed) {
        setBlockLoading(account_uuid)
        try {
          const {data: response} = await BlockUser(account_uuid)
          if (response.code === '200') {
            getUser()
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
              text: response.msg_details,
              allowOutsideClick: true,
            })
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
              text: response.msg_details,
              allowOutsideClick: true,
            })
          }
        } catch (error: any) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: error,
          })
        } finally {
          setBlockLoading(null)
        }
      }
    })
  }

  // function to unblock the users
  const unBlockUser = async (account_uuid: string) => {
    setBlockLoading(account_uuid)
    try {
      const {data: response} = await UnblockUser(account_uuid)
      if (response.code === '200') {
        getUser()
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: response.msg.charAt(0).toUpperCase() + response.msg.slice(1),
          text: response.msg_details,
          allowOutsideClick: true,
        })
      }
    } catch (error: any) {
      Swal.fire({
        position: 'center',
        icon: 'error',
        title: error,
      })
    } finally {
      setBlockLoading(null)
    }
  }

  return (
    <>
      {loading ? (
        // {* Begin: loader*}
        <div
          className='d-flex justify-content-center align-items-center vh-70'
          style={{height: '70vh'}}
        >
          <CircularProgress />
        </div>
      ) : (
        // {* End: loader*}
        // {* Begin: User page content*}
        <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
          <div className='d-flex flex-column flex-column-fluid'>
            {/* Begin: header for user page */}
            <div className='d-flex align-items-center gap-2 gap-lg-3 justify-content-between mb-5 px-5'>
              <div>
                {/* Begin: Heading */}
                <h1
                  className='page-heading d-flex text-dark fw-bold fs-3 my-0
            flex-column justify-content-center'
                >
                  Users
                </h1>
                {/* End: Heading */}

                {/* Begin: Total users heading */}
                <p className='text-muted fw-semibold text-muted d-block fs-7'>
                  {dataLength && `Total users: ${dataLength}`}
                </p>
                {/* End: Total users heading */}
              </div>
              <div className='d-flex align-items-center gap-2 gap-lg-3'>
                {/* Begin: Add users button  */}
                <button
                  onClick={() => setShowAddUserModal(!showAddUserModal)}
                  className='btn btn-sm fw-bold btn-primary'
                >
                  Add new user
                </button>
                {showAddUserModal && (
                  <AddUserModal
                    showAddUserModal={showAddUserModal}
                    handleClose={() => setShowAddUserModal(false)}
                    setItemOffset={setItemOffset}
                    setCurrentPage={setCurrentPage}
                    getUser={getUser}
                  />
                )}
                {/* End: Add users button  */}
              </div>
            </div>
            {/* End: header for user page */}
            {/* Begin: Table */}
            <div id='table div'>
              <div className='card mb-5 mb-xl-8'>
                <div className='card-body py-3'>
                  <div className='table-responsive'>
                    {/* begin::Table */}
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      {/* begin::Table head */}
                      {!noDataFound && (
                        <thead>
                          <tr className='fw-bold text-muted'>
                            {/* <th className='w-25px'>
                            <div className='form-check form-check-sm form-check-custom form-check-solid'>
                              <input
                                className='form-check-input'
                                type='checkbox'
                                value='1'
                                data-kt-check='true'
                                data-kt-check-target='.widget-9-check'
                              />
                            </div>
                          </th> */}
                            <th className='max-w-150px'>Name</th>
                            <th className='max-w-150px'>Contact Details</th>
                            <th className='max-w-100px'>Subscription Details</th>
                            <th className='max-w-50px'>Role</th>
                            <th className='max-w-100px'>Actions</th>
                          </tr>
                        </thead>
                      )}
                      {/* end::Table head */}
                      {/* begin::Table body */}
                      <tbody>
                        {noDataFound ? (
                          <tr>
                            <td colSpan={5}>
                              <span className='d-flex flex-column align-items-center flex-start p-10'>
                                <img
                                  src='/media/svg/undraw/property.svg'
                                  alt='No document uploaded'
                                  className='h-200px w-200px'
                                />
                                <span className='fw-bold text-muted fs-1 text-center'>
                                  No user present
                                </span>
                              </span>
                            </td>
                          </tr>
                        ) : (
                          userData?.map((user, index: number) => {
                            return (
                              <tr key={index}>
                                {/* <td>
                                <div className='form-check form-check-sm form-check-custom form-check-solid'>
                                  <input
                                    className='form-check-input widget-9-check'
                                    type='checkbox'
                                    value='1'
                                  />
                                </div>
                              </td> */}
                                <td className='max-w-100px'>
                                  <div className='d-flex align-items-center'>
                                    <div className='symbol symbol-45px me-3'>
                                      <span className='symbol symbol-50px me-2'>
                                        <span className='symbol-label bg-light-primary'>
                                          {/* {property.property_img_url ? (
                                            <div className='symbol symbol-50px'>
                                              <img
                                                src={property.property_img_url}
                                                alt='Property icon'
                                                style={{objectFit: 'cover'}}
                                              />
                                            </div>
                                          ) : ( */}
                                          <i className='bi bi-person-fill fs-2x btn btn-active-color-primary'></i>
                                          {/* )} */}
                                        </span>
                                      </span>
                                    </div>
                                    <div className='d-flex justify-content-start flex-column'>
                                      <div className='text-dark fw-bold text-hover-primary fs-6'>
                                        <div className='text-truncate max-w-100px'>
                                          {user.accouont_holder_name.charAt(0).toUpperCase() +
                                            user.accouont_holder_name.slice(1)}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className='max-w-150px'>
                                  <div className='d-flex justify-content-start flex-column'>
                                    <div
                                      className='text-truncate max-w-200px text-dark fw-bold fs-6'
                                      title={user.email_id}
                                    >
                                      {user.account_verified === 1 ||
                                      user.account_verified === 3 ? (
                                        <i
                                          className='bi bi-patch-check-fill text-success bi-4x fs-5'
                                          title='Email address is verified'
                                        ></i>
                                      ) : (
                                        <i
                                          className='bi bi-patch-exclamation-fill text-danger bi-4x fs-5'
                                          title='Email address is not verified'
                                        ></i>
                                      )}
                                      {user.email_id}
                                    </div>
                                    <span
                                      className='text-truncate max-w-150px text-muted fw-semibold text-muted d-block fs-7'
                                      title={user.contact_number}
                                    >
                                      {user.account_verified === 2 ||
                                      user.account_verified === 3 ? (
                                        <i
                                          className='bi bi-patch-check-fill text-success bi-4x fs-5'
                                          title='Phone number is verified'
                                        ></i>
                                      ) : (
                                        <i
                                          className='bi bi-patch-exclamation-fill text-danger bi-4x fs-5'
                                          title='Phone number is not verified'
                                        ></i>
                                      )}
                                      {user.contact_number}
                                    </span>
                                  </div>
                                </td>
                                <td className='max-w-100px'>
                                  <span className='text-dark fw-bold text-hover-primary d-block fs-6'>
                                    {user.subscription_name}
                                  </span>
                                  <span
                                    className='text-muted fw-semibold text-muted d-block fs-7'
                                    title={user.subscription_plan_status}
                                  >
                                    {user.subscription_plan_status.charAt(0).toUpperCase() + user.subscription_plan_status.slice(1)}
                                  </span>
                                </td>
                                <td className='max-w-50px'>
                                  <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                    {user.property_account_type_name !== 'null'
                                      ? user.property_account_type_name
                                      : '-'}
                                  </span>
                                </td>
                                <td className='max-w-100px'>
                                  <div className='d-flex flex-shrink-0'>
                                    <button
                                      className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                      onClick={() => navigateProperty(user.account_uuid)}
                                    >
                                      <i
                                        className='bi bi-house-door-fill bi-4x fs-3'
                                        title='Properties'
                                      ></i>
                                    </button>
                                    {!user.subscription_id &&
                                      !user.subscription_name &&
                                      user.subscription_plan_status !== 'subscribed' && (
                                        <>
                                          <button
                                            className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                            onClick={() =>
                                              setShowSubscriptionModal(user.account_uuid)
                                            }
                                          >
                                            <i
                                              className='bi bi-tags-fill bi-4x fs-3'
                                              title='Assign a subscription plan'
                                            ></i>
                                          </button>
                                          {showSubscriptionModal === user.account_uuid && (
                                            <ChangeSubscriptionModal
                                              showSubscriptionModal={showSubscriptionModal}
                                              setShowSubscriptionModal={setShowSubscriptionModal}
                                              accountUUID={user.account_uuid}
                                              getUser={getUser}
                                            />
                                          )}
                                        </>
                                      )}

                                    {user.is_active === 1 ? (
                                      <button
                                        className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                        onClick={() => blockUser(user.account_uuid)}
                                      >
                                        {blockLoading === user.account_uuid ? (
                                          <CircularProgress size='15px' />
                                        ) : (
                                          <i
                                            className='bi bi-check-lg bi-4x fs-2'
                                            title='Account is unblocked, click here to block account'
                                          ></i>
                                        )}
                                      </button>
                                    ) : (
                                      user.is_active === 3 && (
                                        <button
                                          className='border-0 btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                          onClick={() => unBlockUser(user.account_uuid)}
                                        >
                                          {blockLoading === user.account_uuid ? (
                                            <CircularProgress size='15px' />
                                          ) : (
                                            <i
                                              className='bi bi-x bi-4x fs-1'
                                              title='Account is blocked, click here to unblock account'
                                            ></i>
                                          )}
                                        </button>
                                      )
                                    )}
                                  </div>
                                </td>
                              </tr>
                            )
                          })
                        )}
                      </tbody>
                      {/* end::Table body */}
                    </table>
                    {/* end::Table */}
                  </div>
                </div>
              </div>
            </div>
            {/* End: Table */}
          </div>

          {/* Begin: Pagination */}
          {userData && pageCount > 1 && (
            <PaginationComponent
              itemsPerPage={itemsPerPage}
              dataLength={dataLength}
              setItemOffset={setItemOffset}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pageCount={pageCount}
            />
          )}
        </div>
        // {/* End: Pagination */}
        // {/* End: User page content */}
      )}
    </>
  )
}

export default SuperAdminUser
